import React from 'react';

export default function DateDivider({ label }: { label: string }) {
  return (
    <div className="flex items-center justify-center my-4 px-4">
      <div className="flex-1 h-px bg-gray-200" />
      <span className="mx-3 text-[11px] text-gray-600 font-semibold bg-white px-3 py-1 rounded-full border border-gray-200 shadow-sm">
        {label}
      </span>
      <div className="flex-1 h-px bg-gray-200" />
    </div>
  );
}
